// Recover Analytics endpoints, one per section.
//
// NOTHING UNDER analytics/ IS WIRED TO THE BACKEND YET. The contract these calls are written
// against is docs/temp/disputes-analytics-backend-tz.md; the real request sits commented out above
// each mock, so switching over is uncommenting it, deleting the mock line, and adding:
//
//   import { request } from "../../../Services/Api"
//
// The queue cards are the exception: they read the dispute statistics the Disputes list already
// uses, which do exist.
import { getDisputesStatistics } from "../../DisputesPage/api/services"
import * as mock from "./mock.data"

// True while the analytics endpoints below are mocks. The page's "No disputes yet" state and
// DisputesShell both read the account's real profile and disputes, which would hide the mocked
// pages on an account without them. Delete together with the mocks, and put the six Analytics
// routes back inside DisputesShell (InitComponent/InternalPages.js).
export const ANALYTICS_MOCKED = true

// apisauce shape after a network-like pause, so the section spinners and the slice's
// stale-response guard run the way they will against the real endpoints.
const mockResponse = (data) =>
  new Promise((resolve) => {
    setTimeout(() => resolve({ ok: true, status: 200, data }), 300 + Math.random() * 500)
  })

export const getAnalyticsQueue = (params) => getDisputesStatistics(params)

export const getAnalyticsKpis = (params) =>
  // request.api.get("/dispute-management/analytics/kpis/", params)
  mockResponse(mock.getKpis(params))

export const getAnalyticsTrend = (params) =>
  // request.api.get("/dispute-management/analytics/trend/", params)
  mockResponse(mock.getTrend(params))

export const getAnalyticsFlow = (params) =>
  // request.api.get("/dispute-management/analytics/flow/", params)
  mockResponse(mock.getFlow(params))

export const getAnalyticsByCategory = (params) =>
  // request.api.get("/dispute-management/analytics/by-category/", params)
  mockResponse(mock.getByCategory(params))

export const getAnalyticsByCountry = (params) =>
  // request.api.get("/dispute-management/analytics/by-country/", params)
  mockResponse(mock.getByCountry(params))

export const getAnalyticsByCardNetwork = (params) =>
  // request.api.get("/dispute-management/analytics/by-card-network/", params)
  mockResponse(mock.getByCardNetwork(params))

export const getAnalyticsWinRateMatrix = (params) =>
  // request.api.get("/dispute-management/analytics/win-rate-matrix/", params)
  mockResponse(mock.getWinRateMatrix(params))

export const getAnalyticsRepeatDisputers = (params) =>
  // request.api.get("/dispute-management/analytics/repeat-disputers/", params)
  mockResponse(mock.getRepeatDisputers(params))

export const getAnalyticsCategoryTrends = (params) =>
  // request.api.get("/dispute-management/analytics/category-trends/", params)
  mockResponse(mock.getCategoryTrends(params))

export const getAnalyticsActivity = (params) =>
  // request.api.get("/dispute-management/analytics/activity/", params)
  mockResponse(mock.getActivity(params))
